// extracted by mini-css-extract-plugin
export default {"price_order":"main_price_order__Y6otV","price_add_to_wallet":"main_price_add_to_wallet__Dj2Zl","span_points":"main_span_points__fGKZZ","greenActive":"main_greenActive__vGJSh"};